import { api } from './api'

export const verifyPhoneNumber = ({
  userId,
  code,
  phoneNumber,
  fingerprint,
}: {
  userId: number
  code: string
  phoneNumber: string
  fingerprint: string
}) =>
  api.put(`/users/${userId}/phone_number/verify`, {
    code,
    phone_number: phoneNumber,
    fingerprint,
  })
